import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import find from 'lodash/find';
import airbrake from 'util/airbrake';

import { screens } from 'actions/onboarding';
import styles from './style.module.scss';

export class ProfileSidebar extends PureComponent {
  static propTypes = {
    lastActiveScreenIndex: PropTypes.number.isRequired,
    areasOfInterest: PropTypes.array,
  };

  static defaultProps = {
    areasOfInterest: [],
  };

  render() {
    const { lastActiveScreenIndex } = this.props;
    let showBlurb = true;
    if (this.props.areasOfInterest && this.props.areasOfInterest.length > 0) {
      const market = find(this.props.areasOfInterest, { __typename: 'Market' });
      if (!market) {
        airbrake.notify('Market could not be found in areasOfInterest');
        showBlurb = false;
      }
    }
    return (
      <header className={styles.header}>
        <div className={styles.headerLogo}>
          <Link to="/">
            <img
              src={require('assets/images/brand-mark.svg')}
              alt="brand"
              className={styles.brandIcon}
            />
            <img
              src={require('assets/images/brand-text.svg')}
              alt="squarefoot"
              title="SquareFoot"
              className={styles.brandText}
            />
          </Link>
        </div>
        <nav className={styles.nav}>
          <ul>
            {screens.map((step, index) => (
              <li
                key={`step-${step.name}`}
                className={
                  index <= lastActiveScreenIndex
                    ? styles.activeStep
                    : styles.inactiveStep
                }
              >
                {index <= lastActiveScreenIndex && (
                  <NavLink to={step.link} activeClassName={styles.activeLink}>
                    {step.name}
                  </NavLink>
                )}
                {index < lastActiveScreenIndex && (
                  <span className="icon-check" />
                )}
                {(index > lastActiveScreenIndex || !showBlurb) && (
                  <span>{step.name}</span>
                )}
                {index < lastActiveScreenIndex && showBlurb && step.blurb && (
                  <p>{step.blurb(this.props)}</p>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <nav className={styles.contact}>
          <ul>
            <li>
              <strong className="desktop-only">Have questions?</strong>
            </li>
            <li>
              <a href="tel:+19179941062">
                <span className="icon-phone" />
                <span className="desktop-only"> (917) 994-1062</span>
              </a>
            </li>
          </ul>
        </nav>
      </header>
    );
  }
}

export default connect((state) => ({
  ...state.onboarding,
}))(ProfileSidebar);
